import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        routeDom: {

        },
        joinRef: 'designDom',
        helpRef: 'account',
        agreement: 'agreement0'
    },
    actions: {
    },
    mutations: {
        changeRouteDom: function (state, doms) {
            state.routeDom = doms
        },
        changeRef: function (state, data) {
            let key = data.key
            let val = data.value
            state[key] = val
        }

    }
})



// WEBPACK FOOTER //
// ./src/store/index.js